var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-item",class:{ selected: _vm.curActiveChildCath == _vm.catPath }},[_vm._v("\n\t"+_vm._s(_vm.tabName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }